import * as React from "react";
import styled from "@emotion/styled";

type BadgeProps = React.PropsWithChildren<{
  hide?: boolean;
  size?: number;
  fontWeight?: number;
  className?: string;
}>;

export default function Badge({
  children,
  hide,
  size,
  fontWeight,
  className,
}: BadgeProps): JSX.Element {
  return (
    <BadgeComponent hide={hide} size={size} fontWeight={fontWeight} className={className}>
      {children}
    </BadgeComponent>
  );
}

const BadgeComponent = styled.span<{ hide?: boolean; size?: number; fontWeight?: number }>(
  ({ hide, size, theme, fontWeight = 700 }) => ({
    display: hide ? "none" : "inline-flex",
    fontWeight: fontWeight,
    backgroundColor: theme.colors.sysBrandBlueDefault,
    borderRadius: "50%",
    color: theme.colors.sysTextWhite,
    height: size ? size : 14,
    width: size ? size : 14,
    fontSize: size ? size - 6 : 8, // adjust font size based on size prop
    justifyContent: "center",
    alignItems: "center",
    marginLeft: 8,
  }),
);
